import React from 'react';
import { Section } from '@layout';
import { H2 } from '@heading';
import { Button } from '@input';
import styles from './MeetAradhna.module.scss';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

export default function MeetAradhna() {
  const { bg, photo } = useStaticQuery(query);

  const { large, medium, small } = photo.childImageSharp;

  return (
    <Section
      className={styles.wrapper}
      backgroundImage={bg}
      loading="eager"
      fillContainer
    >
      <div className={styles.content}>
        <H2>Meet Aradhna</H2>
        <p>
          Aradhna is an associate professor UCLA and is affiliated with the
          Department of Atmospheric and Oceanic Sciences, the Department of
          Earth, Planetary, and Space Sciences, the Institute of the
          Environment and Sustainability, the Institute of Geophysics and
          Planetary Physics, the American Indian Studies Center, and the
          California Nanosystems Institute.
        </p>
        <p>
          Aradhna is also the founder &amp; director of{' '}
          <Link to="/diversity-center">
            the Center for Diverse Leadership in Science
          </Link>
          , with the goal to educate, recruit, and retain a diverse
          population into environmental science and geoscience.
        </p>
        <Button
          to="/lab/aradhna-tripati"
          theme="white"
          icon="scholar"
        >
          Read my full bio
        </Button>
      </div>
      <div className={styles.photoWrapper}>
        <Img
          fixed={[
            { ...large, media: '(min-width: 1281px)' },
            { ...medium, media: '(min-width: 621px)' },
            { ...small, media: '(max-width: 620px)' }
          ]}
          className={styles.photo}
          alt="Aradhna Tripati"
          fadeIn={false}
          loading="eager"
        />
      </div>
      <div className={styles.gradient} />
    </Section>
  );
}

const query = graphql`
  query BioImageQuery {
    bg: file(relativePath: { eq: "About/MeetAradhna/bg.jpg" }) {
      childImageSharp {
        fluid(quality: 80, maxWidth: 1320) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }

    photo: file(relativePath: { eq: "About/MeetAradhna/aradhna.png" }) {
      childImageSharp {
        large: fixed(quality: 80, width: 709, height: 730) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }

        medium: fixed(quality: 80, width: 620, height: 638) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }

        small: fixed(quality: 80, width: 510) {
          ...GatsbyImageSharpFixed_withWebp_noBase64
        }
      }
    }
  }
`;
